import TicketsCart from './TicketsCart'

function App() {
	return (
		<div className='bg-gray-50 pt-6'>
			<div className='mx-auto max-w-4xl sm:px-6 lg:px-8'>
				<h1 className='text-3xl font-bold tracking-tight text-gray-900 text-center !mt-0 !mb-6'>
					Köp din biljett här
				</h1>
				<TicketsCart />
			</div>
		</div>
	)
}

export default App
